import Vue from "vue";
const vm = new Vue()
import courierRules from "@/constants/CourierRules";

export const checkWeightRules = ( courierCode , weight ) => {
    let status = false
    let msg = ''
    let weightParcel = (vm.$THEME.unitKG) ? weight*1000 : weight
    
    if( weightParcel <= 0 ){
        status = true;
        msg = 'กรุณาใส่น้ำหนักมากกว่า 0'+ (vm.$THEME.unitKG ? ' กิโลกรัม' : ' กรัม') 
    }else if(
        courierRules[courierCode].maxWeight &&
        weightParcel > courierRules[courierCode].maxWeight
    ){
        status = true;
        msg = 'น้ำหนักพัสดุต้องไม่เกิน '
            + (vm.$THEME.unitKG 
                ? (courierRules[courierCode].maxWeight/1000)
                : courierRules[courierCode].maxWeight )
            + (vm.$THEME.unitKG ? ' กิโลกรัม' : ' กรัม') 
    }else{
        status = false;
        msg = ''
    }

    return { status: status , msg: msg }
}
